<template>
    <div class="financeCalculator__form__input financeCalculator__form__input--select">
        <div class="financeCalculator__form__selectPlaceholder" v-if="selectedOption">
            {{ selectedOption.label }}
        </div>

        <select :name="name"
                :id="id"
                :autocomplete="autocomplete"
                :disabled="disabled"
                v-model="selected"
        >
            <slot />
            <option :value="option[optionValueKey]" v-for="option in options" :key="option[optionValueKey]">
                {{ option[optionLabelKey] }}
            </option>
        </select>
    </div>
</template>

<script>
export default {
    props: {
        name: {
            type: String,
        },
        autocomplete: {
            type: String,
        },
        readonly: {
            type: String,
        },
        disabled: {
            type: Boolean,
            default: false
        },
        maxlength: {
            type: Number,
        },
        id: {
            type: String,
        },
        options: {
            type: Array,
            default: () => []
        },
        optionLabelKey: {
            type: String,
            default: 'label'
        },
        optionValueKey: {
            type: String,
            default: 'value'
        },
        value: {
            type: String,
            default: ''
        }
    },
    computed: {
        selected: {
            get() {
                return this.value
            },
            set(val) {
                this.$emit('input', val)
            }
        },
        selectedOption() {
            return this.options.find((o) => o[this.optionValueKey] === this.selected)
        }
    }
}
</script>